import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENTS_COLUMNS_TOKEN, UNREAD_REPORTS_STORAGE } from '../documents';
import { InvestigatorDocumentsColumns } from './investigator-documents-columns';
import { InvestigatorUnreadReportsStorage } from './investigator-unread-reports-storage';
import { LabTestsGridColumns } from '../subjects/lab-tests-grid-columns';
import { LAB_TEST_RESULTS_LINK_BUILDER } from '../subjects/lab-test-results-link-builder';
import { InvestigatorLabTestResultsLinkBuilder } from './investigator-lab-test-results-link-builder';
import { SiteRouteDataStorage } from './site-route-data-storage';

@Component({
    selector: 'investigator-level',
    template: '<router-outlet class="flex-router-outlet"></router-outlet>',
    providers: [
        SiteRouteDataStorage,
        { provide: DOCUMENTS_COLUMNS_TOKEN, useClass: InvestigatorDocumentsColumns },
        { provide: UNREAD_REPORTS_STORAGE, useExisting: InvestigatorUnreadReportsStorage },
        { provide: LAB_TEST_RESULTS_LINK_BUILDER, useClass: InvestigatorLabTestResultsLinkBuilder },
        LabTestsGridColumns
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestigatorLevelComponent { }
